module.exports = __webpack_public_path__ + "static/media/check-img.9aa3fe49.png";